
<template>
  <div class="store-close-agree-box">
    <div class="fromLoading" v-show="isPageLoading">
      <Spin></Spin>
    </div>
    <div class="input_box">
      <!-- <span class="lable">*</span> -->
      <span class="label-txt">审批意见：</span>
      <Input class="ref_input" v-model="inputValue" placeholder="审批意见" />
    </div>
    <div class="pop-btn">
      <Button type="error" class="sav-btn" @click="objectSave">
        <span>{{ chineseName.CONFIRM }}</span>
      </Button>
      <Button class="cancel-btn" @click="cancel">
        <span>{{ chineseName.CANCEL }}</span>
      </Button>
    </div>
  </div>
</template>

<script>
import ChineseDictionary from '@/assets/js/ChineseDictionary';
import axios from "axios";

export default {
  name: 'StoreCloseAgree',
  inject: ['moduleComponentName', 'instanceRouteQuery', 'instanceRoute'],
  data() {
    return {
      inputValue: '',
      isPageLoading: true,
    };
  },
  created() {
    this.chineseName = ChineseDictionary;
  },
  mounted() {
    console.log('window.jflowEventParamWithStoreClose :>> ', window.jflowEventParamWithStoreClose);
    if (window.jflowEventParamWithStoreClose) {
      this.approveAction()
    } else {
      this.$emit('closeActionDialog', true); // 关闭弹框

      this.$Modal.fcWarning({
        mask: true,
        title: '警告',
        content: 'jflowEventParam数据错误，请重试',
        onOk: _ => {
          this.$store.commit("global/tabCloseAppoint", {
            tableName: this.instanceRouteQuery.tableName, //(主表表名),
            routeFullPath: this.instanceRoute, //（路由path）
          });
        }
      });
    }
  },
  activated() { },
  destroyed() { },
  methods: {
    approveAction() {
      const { tableId, itemId } = this.$router.currentRoute.params;

      axios({
        url: '/jflow/p/cs/task/page/approveAction',
        method: 'post',
        data: {
          businessCode: itemId,
          userId: this.$store.state.global.userInfo.id,
          businessType: tableId,
        }
      }).then(res => {
        if (res.data.resultCode == 0) {
          this.businessChange()
        }
      })
    },
    businessChange() {
      const { tableName, tableId, itemId } = this.$router.currentRoute.params;
      axios({
        url: '/jflow/p/cs/business/change',
        method: 'post',
        data: {
          async: true,
          businessCode: itemId,
          businessType: tableId,
          businessTypeName: tableName,
          instanceId: window.jflowEventParamWithStoreClose.instanceId,
        }
      }).then(res => {
        if (res.data.resultCode == 0) {
          this.isPageLoading = false
        }
      })
    },
    objectSave() {
      const { tableName, tableId, itemId } = this.$router.currentRoute.params;
      let data = {}
      data[tableName] = {};
      
      let formdata = new FormData();
      formdata.append('table', tableName);
      formdata.append('objid', itemId);
      formdata.append('data', JSON.stringify(data));
      formdata.append('after', JSON.stringify(data));
      formdata.append('before', JSON.stringify(data));
			// console.log("TCL: objectSave -> formdata", formdata)
      R3.network.post('/p/cs/objectSave', formdata).then(res => {
        if (res.data.code == 0) {
          // this.$Message.success(res.data.message);
          this.pass()
        } else {
          this.$Message.error(res.data.message);
        }
      })
    },
    pass() {
      const { tableName, tableId, itemId } = this.$router.currentRoute.params;
      axios({
        url: '/jflow/p/cs/task/page/pass',
        method: 'post',
        data: {
          businessCode: itemId,
          businessName: tableName,
          businessType: tableId,
          description: this.inputValue,
          instanceId: window.jflowEventParamWithStoreClose.instanceId,
          nodeId: window.jflowEventParamWithStoreClose.nodeId,
          userId: this.$store.state.global.userInfo.id,
        }
      }).then((res) => {
        if (res.data.resultCode == 0) {
          this.$Modal.fcSuccess({
            title: '成功',
            content: '成功',
          });
          this.$emit('closeActionDialog', true); // 关闭弹框
        } else {
          this.$Modal.fcError({
            title: '失败',
            content: res.data.resultMsg,
          });
        }
      });
    }, // 确定
    cancel() {
      this.$emit('closeActionDialog', false); // 关闭弹框
    }, // 取消
  },
};
</script>

<style lang="less">
.store-close-agree-box {
  .input_box {
    display: flex;
    flex-direction: row;
    align-items: center;
    .lable {
      //   padding-top: 12px;
      padding-right: 6px;
      color: red;
    }
    .label-txt {
      display: inline-block;
      width: 80px;
    }
  }
  .ref_input {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .pop-btn {
    display: flex;
    flex-direction: row-reverse;

    .cancel-btn {
      margin-right: 10px;
    }
  }
  .fromLoading {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 1000 !important;
  }
}
</style>